




























































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class AppSelector extends Vue {
  @Prop([Number, String]) readonly value!: number
  @Prop(String) readonly label!: string
  @Prop({ type: String }) readonly placeholder!: string
  @Prop({ type: Number, default: 289 }) readonly width!: number
  @Prop({ type: [Number, String], default: 36 }) readonly height!: number | string
  @Prop({ type: Array }) readonly items!: string[]
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
  @Prop({ type: String, default: '' }) readonly className!: string
  @Prop({ type: Number, default: 100 }) readonly labelWidth!: number
  @Prop({ type: Boolean, default: false }) readonly required!: boolean

  model = ''

  selectedIdx = -1

  entering = false

  showList = false

  get options () {
    return this.required ? this.items : ['-', ...this.items]
  }

  mounted () {
    this.onValueChanged(this.value)
  }

  @Watch('value')
  onValueChanged (val: number) {
    this.model = this.items[val] || ''
    return Number(val)
  }

  @Watch('options')
  onOptionsChanged () {
    this.model = this.items[this.value] || ''
  }

  @Emit('input')
  valueChangedHandler (val: string, index?: number) {
    index = index === undefined ? -1 : index
    this.model = val
    if (this.required) {
      return Number(index)
    } else {
      return Number(index) > -1 ? Number(index) - 1 : -1
    }
  }

  @Emit()
  submit () {
    // do nothing
  }

  @Watch('model')
  onModelChanged () {
    this.searchHandler()
  }

  @Emit('search')
  searchHandler () {}

  clearModel () {
    this.model = ''
    this.valueChangedHandler('')
    this.searchHandler()
  }

  keyDownHandler (e: KeyboardEvent) {
    const selectedIdx = !isNaN(this.selectedIdx)
      ? this.selectedIdx
      : -1

    if (e.key !== 'Enter') {
      this.entering = false
    }

    switch (e.key) {
      case 'ArrowUp' :
        this.selectedIdx = selectedIdx - 1 < 0 ? 0 : selectedIdx - 1
        break
      case 'ArrowDown' :
        this.selectedIdx = selectedIdx + 1 > this.items.length - 1 ? this.items.length - 1 : selectedIdx + 1
        break
      case 'Enter' :
        if (this.entering) {
          return
        }
        this.entering = true
        this.valueChangedHandler(this.items[selectedIdx], selectedIdx)
    }
  }
}
